import { useSimperStore } from "@/stores"
import { RollbackOutlined, LoadingOutlined } from "@ant-design/icons"
import { Button } from "@/components/ui/button"
import { Empty, Spin } from "antd"
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import EmployeeInfoCard from "./components/EmployeeInfoCard"
import SimperHistoryCard from "./components/SimperHistoryCard"
import SimperQrCard from "./components/SimperQrCard"
import { Card, CardContent } from "@/components/ui/card"

const SimperDetails = () => {
  const { simperNumber } = useParams<{ simperNumber: string }>()
  const navigate = useNavigate()
  const { currentSimper, simperQr, isLoading, fetchSimperRecordBySimperNumber, fetchSimperQrBySimperNumber } = useSimperStore()

  useEffect(() => {
    if (simperNumber) {
      void fetchSimperRecordBySimperNumber(simperNumber)
      void fetchSimperQrBySimperNumber(simperNumber)
    }
  }, [simperNumber, fetchSimperRecordBySimperNumber, fetchSimperQrBySimperNumber])

  const downloadQRCode = () => {
    const svg = document.getElementById("simper-qr-code")
    if (!svg) return

    const svgData = new XMLSerializer().serializeToString(svg)
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    const img = new Image()

    img.onload = () => {
      canvas.width = img.width + 40 // padding
      canvas.height = img.height + 40
      if (ctx) {
        ctx.fillStyle = "white"
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 20, 20)
        const pngFile = canvas.toDataURL("image/png")
        const downloadLink = document.createElement("a")
        downloadLink.download = `QR_Simper_${currentSimper?.simper_number || "download"}.png`
        downloadLink.href = pngFile
        downloadLink.click()
      }
    }

    img.src = "data:image/svg+xml;base64," + btoa(svgData)
  }

  if (isLoading && !currentSimper) {
    return (
      <div className="flex flex-col justify-center items-center h-[400px] gap-4">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} />
        <span className="text-muted-foreground font-medium animate-pulse">Loading simper details...</span>
      </div>
    )
  }

  if (!currentSimper) {
    return (
      <Card className="border-none shadow-sm h-[300px] flex items-center justify-center">
        <CardContent className="flex flex-col items-center">
          <Empty description="Simper data not found" className="grayscale opacity-60" />
          <Button variant="default" className="mt-6 shadow-md" onClick={() => navigate("/simper")}>
            Back to List
          </Button>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="flex flex-col gap-6 p-2">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        <div className="lg:col-span-3 flex flex-col gap-6">
          <EmployeeInfoCard currentSimper={currentSimper} />
          <SimperHistoryCard simperData={currentSimper.simper_data} />
        </div>

        <div className="lg:col-span-1">
          <SimperQrCard simperQr={simperQr} downloadQRCode={downloadQRCode} />
        </div>
      </div>
    </div>
  )
}

export default SimperDetails
